import React, { Component } from "react";
import "../Account.css";
import SignupHeader from "./signup.header";
import SignupFooter from "./signup.footer";
import { Link } from "react-router-dom";
import axios from "axios";

class ForgottenPassword extends Component {
  state = {
    email: "",
    loading: false,
    message: null,   // text to show
    status: null,    // "success" | "error" | null
  };

  messageTimer = null;

  componentWillUnmount() {
    clearTimeout(this.messageTimer);
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  getErrorMessage = (error) => {
    // No response at all: network down, CORS, server unreachable
    if (!error.response) {
      return "Network error. Please check your connection and try again.";
    }

    const { status, data } = error.response;

    if (status === 429) {
      return "Too many attempts. Please wait a few minutes and try again.";
    }
    if (status >= 500) {
      return "Server error. Please try again later.";
    }

    // DRF-style errors
    if (typeof data === "string" && data.length < 200) return data;
    if (data?.detail) return data.detail;
    if (data?.error) return data.error;
    if (data?.message) return data.message;
    if (Array.isArray(data?.email)) return data.email.join(" ");
    if (Array.isArray(data?.non_field_errors)) return data.non_field_errors.join(" ");

    if (status === 404) return "No account was found with that email.";
    return "Something went wrong. Please try again.";
  };

  showMessage = (message, status, autoHideMs) => {
    clearTimeout(this.messageTimer);
    this.setState({ message, status });
    if (autoHideMs) {
      this.messageTimer = setTimeout(() => {
        this.setState({ message: null, status: null });
      }, autoHideMs);
    }
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    if (this.state.loading) return; // block double submits

    clearTimeout(this.messageTimer);
    this.setState({ loading: true, message: null, status: null });

    try {
      await axios.post("https://api.geoinfoacademy.com/api/password-reset/", {
        email: this.state.email.trim(),
      });

      this.setState({ email: "" });
      this.showMessage("A reset link has been sent to your email.", "success");
    } catch (error) {
      console.error("Password reset error:", error);
      this.showMessage(this.getErrorMessage(error), "error", 7000);
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { email, loading, message, status } = this.state;

    return (
      <div className="account_body forgotten">
        <SignupHeader />
        <h1 className="account_header">Forgotten Password</h1>
        <div className="account_form_cover">
          <form className="account_form" onSubmit={this.handleSubmit}>
            <label htmlFor="email">Email</label><br />
            <input
              placeholder="Enter Your Email"
              type="email"
              id="email"
              name="email"
              value={email}
              onChange={this.handleChange}
              disabled={loading}
              required
            /><br /><br />

            <p>
              We’ll send a password reset link to this email if it matches an
              existing Geoinfotech Academy account.
            </p><br />

            <button type="submit" disabled={loading}>
              {loading ? "Sending..." : "Next"}
            </button><br /><br />

            <Link to="/login">
              <button type="button" disabled={loading}>Back</button>
            </Link><br /><br />

            {message && (
              <p
                className={status === "success" ? "account_success" : "account_error"}
                role={status === "error" ? "alert" : "status"}
              >
                {message}
              </p>
            )}
          </form>
        </div>
        <SignupFooter />
      </div>
    );
  }
}

export default ForgottenPassword;




// import React, { Component } from "react";
// import "../Account.css"
// import SignupHeader from "./signup.header";
// import SignupFooter from "./signup.footer";
// import { Link } from "react-router-dom";
// import axios from "axios";


// class ForgottenPassword extends Component {
//     state = {
//         email: '',
//         error: null,
//     }
//     handleChange = (event) => {
//         this.setState({ [event.target.name]: event.target.value });
//       };
//       handleSubmit = async (event) => {
//         event.preventDefault();
    
//         try {
//           const response = await axios.post('https://api.geoinfoacademy.com/api/password-reset/', {
//             email: this.state.email
//           });
    
//           // response from the backend to check mail
//           this.setState({ error: "A link have being sent to your email" });
//           console.log(response.data)
//         } catch (error) {
//           this.setState({ error: 'Error occurred, try again' });
//           setTimeout(() => {
//             this.setState({ error: '' });
//           }, 5000); 
//         }
//       };
//     render() {
//         return (
//             <div className=" account_body forgotten">
//                 <SignupHeader />
//                 <h1 className="account_header">Forgotten Password</h1>
//                 <div className="account_form_cover">
//                     <form className="account_form" onSubmit={this.handleSubmit}>
//                         <label>Email</label><br />
//                         <input placeholder="Enter Your Email " type="email" id="email" name="email" value={this.state.email} onChange={this.handleChange} required /><br /><br />
//                         <p>We’ll send a verification code to this email or phone number if it matches an existing Geoinfotech Academy account.</p><br />
//                         <button type="submit">Next</button> <br /><br />
//                         <Link to="/login"><button>Back</button></Link><br /><br />
//                         {this.state.error && <p className="account_error">{this.state.error}</p>}
//                     </form>
//                 </div>
//                 <SignupFooter />
//             </div>
//         )
//     }
// }

// export default ForgottenPassword